import { Dimensions, OwnedTargetInfo, SnapshotData } from 'ais-facade-api/api';
import { SHIP_TYPES_COLORS } from '../constants/_constants';
import { EtaT } from '../types/types';

export const getInfoByType = (type?: number) => {
  if (type) {
    const findInCodes = SHIP_TYPES_COLORS.find((item) => item.codes.includes(type));
    return {
      color: findInCodes?.color || '#CDCDCD',
    };
  } else {
    return {
      color: '#CDCDCD',
    };
  }
};

export const radToDeg = (rad: number | undefined) => {
  return typeof rad === 'number' ? (rad / 180) * Math.PI : 0;
};

export const getEta = (eta: EtaT) => {
  const dateAsArray = [eta.day, eta.month, eta.year];
  const timeAsArray = [eta.hour, eta.minute];
  let etaDate = '';
  let etaTime = '';

  dateAsArray.forEach((item) => {
    if (item !== undefined && item >= 10) {
      etaDate = etaDate.concat(item.toString() + '.');
    } else if (item !== undefined && item < 10) {
      etaDate = etaDate.concat('0' + item.toString() + '.');
    }
  });

  timeAsArray.forEach((item) => {
    if (item !== undefined && item >= 10) {
      etaTime = etaTime.concat(item.toString() + ':');
    } else if (item !== undefined && item < 10) {
      etaTime = etaTime.concat('0' + item.toString() + ':');
    }
  });

  return etaDate.slice(0, -1) + `${etaDate && etaTime && ', '}` + etaTime.slice(0, -1);
};

export const getDimensions = ({ toBow, toPort, toStarboard, toStern }: Dimensions) => {
  const _toBow = toBow !== undefined ? toBow : 0;
  const _toStern = toStern !== undefined ? toStern : 0;
  const _toPort = toPort !== undefined ? toPort : 0;
  const _toStarboard = toStarboard !== undefined ? toStarboard : 0;

  const toBowStern = _toBow + _toStern !== 0 ? _toBow + _toStern : null;
  const toPortStarboard = _toPort + _toStarboard !== 0 ? _toPort + _toStarboard : null;
  return { toBowStern: toBowStern, toPortStarboard: toPortStarboard };
};

export const getShipName = (ship: OwnedTargetInfo | SnapshotData | undefined) => {
  if (!ship) return;

  if ('staticData' in ship || 'registryData' in ship) {
    if (ship.registryData?.name) return ship.registryData.name;
    if (ship.staticData?.name) return ship.staticData.name;
    if (ship.staticData?.imo) return ship.staticData.imo;
  }
  if (ship.mmsi) {
    return ship.mmsi;
  }
};

export const BASE_URL = process.env.NODE_ENV === 'development' ? window._env_.APP_DEV_API : window._env_.APP_API;
